export default "__VITE_ASSET__Cf6v2ksM__"